import React, { useEffect, useState } from "react";
import {
  IThemeConfig,
  useTheme,
  getConfig,
  PageTitle,
  PageDescription,
} from "../../../../_start/layout/core";
import { AdminDashboardPage } from "./AdminDashboardPage";
import { ErrorBoundary } from "../../../components/ErrorBoundary";
import store from "../../../../setup/redux/Store";

const defaultPageConfig = getConfig();
const adminPageConfig: Partial<IThemeConfig> = {
  aside: {
    ...defaultPageConfig.aside,
    display: true,
    primaryDisplay: true,
    secondaryDisplay: false,
    toggle: true,
    content: "menu",
  },
  toolbar: {
    ...defaultPageConfig.toolbar,
    display: false,
  },
  sidebar: {
    ...defaultPageConfig.sidebar,
    display: false,
  },
};

export function AdminDashboardWrapper() {
  const { setTheme } = useTheme();
  const [userID, setUserID] = useState<string | null>(null);

  useEffect(() => {
    const uid = store.getState().auth?.user?.uid ?? null;
    setUserID(uid);
    setTheme(adminPageConfig);
    return () => {
      setTheme(defaultPageConfig);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PageTitle>Admin Dashboard</PageTitle>
      <PageDescription>Business Foundry — Platform analytics</PageDescription>
      {userID && (
        <ErrorBoundary>
          <AdminDashboardPage userID={userID} />
        </ErrorBoundary>
      )}
    </>
  );
}
